import { DropdownButton } from '@neo4j-ndl/react';
import { useConnection } from '@nx/state';
import type { DbmsInfo } from '@nx/state/desktop';
import { DBMS_STATUS, useDbmsList } from '@nx/state/desktop';
import { useRef, useState } from 'react';

import { ConnectionStatusIndicator } from './connection-status-indicator';
import { InfoItem } from './info-item';
import { InstanceMenu } from './instance-menu';

type Connection = ReturnType<typeof useConnection>;

const getLocalInstanceName = (instances: DbmsInfo[], connection: Connection) => {
  if (connection.status.isConnected) {
    const instance = instances.find(
      ({ connectionUri, status }) => status === DBMS_STATUS.STARTED && connectionUri === connection.metadata?.url,
    );

    if (instance) {
      return instance.name;
    }

    return connection.metadata?.url;
  }

  return '';
};

export function LocalInstanceMenuButton() {
  const connection = useConnection();
  const { dbmss } = useDbmsList();

  const buttonRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const showInstanceName = !connection.status.isDisconnected;

  return (
    <>
      <DropdownButton
        aria-label="Toggle instance menu"
        htmlAttributes={{ 'data-testid': 'instance-menu-button' }}
        size="small"
        ref={buttonRef}
        isOpen={isMenuOpen}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        leftIcon={<ConnectionStatusIndicator />}
        className="border-none"
      >
        <InfoItem
          label={showInstanceName ? 'Instance:' : 'No instance connected'}
          value={getLocalInstanceName(dbmss, connection)}
        />
      </DropdownButton>

      <InstanceMenu isMenuOpen={isMenuOpen} anchorEl={buttonRef} onClose={() => setIsMenuOpen(false)} />
    </>
  );
}
